import { create } from "zustand";

interface FilterState {
  selectedFilterField: any;
  filters: any[];
  filterPayload: any[];

  setSelectedFilterField: (data: string) => void;
  setFilters: (value: any[]) => void;
  setFilterPayload: (value: any[]) => void;
  onDeleteFilterBy: (itemName: string) => void;
  onDeleteAllFilters: () => void;
}

export const useFilterStore = create<FilterState>((set, get) => ({
  selectedFilterField: "",
  filters: [],
  filterPayload: [],

  setSelectedFilterField: (field) => {
    set({ selectedFilterField: field });

    if (field) {
      const { filters } = get();

      const isAlreadySorted = filters.some((filter) => filter.field === field);

      if (!isAlreadySorted) {
        set({
          filters: [...filters, field],
        });
      }
    }
  },

  setFilters: (value: any[]) => {
    set({ filters: value });
  },

  setFilterPayload: (value: any[]) => {
    set({ filterPayload: value });
  },

  onDeleteFilterBy: (itemName: string) => {
    const newFilters = get()?.filters.filter((f) => f?.filter?.by !== itemName);

    if (newFilters.length === 0) {
      set({ filters: [], filterPayload: [], selectedFilterField: "" });
    } else {
      set({ filters: newFilters });
    }
  },

  onDeleteAllFilters: () => {
    set({ filters: [], filterPayload: [], selectedFilterField: "" });
  },
}));
